import React from 'react';
import t from '~t';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { set } from '~data/actions/config';
import { isPro } from '~data/selectors/user';
import config from '~config';

import { Label, Checkbox, SubLabel } from '~ui';

export default function SettingsAppAi() {
  const ai_suggestions = useSelector((state) => state.config.ai_suggestions);
  const ai_assistant = useSelector((state) => state.config.ai_assistant);
  const pro = useSelector(isPro);
  const dispatch = useDispatch();

  return (
    <>
      <Label>AI</Label>
      <div>
        <Checkbox
          checked={ai_assistant}
          onChange={() => dispatch(set('ai_assistant', !ai_assistant))}
        >
          {t.s('ask')} AI
          <a href={config.links.help.stella.index} target='_blank'>
            [?]
          </a>
        </Checkbox>

        <Checkbox
          checked={ai_suggestions}
          onChange={() => dispatch(set('ai_suggestions', !ai_suggestions))}
        >
          {t.s('suggestedCollectionsAndTags')}
        </Checkbox>

        <SubLabel>
          {!pro && (
            <>
              Only available for <Link to='/settings/pro'>Pro</Link>.{' '}
            </>
          )}
          {t.s('aiDescription')}
        </SubLabel>
      </div>
    </>
  );
}
